<template>
  <div class="room-quality-modal-component">
    <div class="room-setting-modal">
      <div class="room-setting-header">
        <div class="room-setting-title-wrapper">
          <h5 class="room-setting-title">{{ this.$t('displayQuality.title') }}</h5>
          <GrmCloseBtn @click="onClose" />
        </div>
      </div>
      <div class="room-setting-body">
        <div class="room-setting-content-text-box">
          <p class="room-setting-content-text">{{ this.$t('displayQuality.text') }}</p>
        </div>
        <div class="room-setting-input-box">
          <div class="room-set-block-btn-box">
            <ul>
              <li
                v-for="quality in qualityList"
                :key="quality.type"
                :class="{ selected : userVideoQuality == quality.type }"
                @click="onClickQuality(quality.type)">
                <button class="room-set-block-btn" tabindex="1">{{ quality.name }}</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn"
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'RoomQualitySettingModal',
  components:{
    GrmCloseBtn
  },
  computed:{
    ...mapGetters('user', ['userVideoQuality', 'me']),
    ...mapGetters('call', ['roomCall']),
  },
  data(){
    return{
      qualityList: [
        {type : 'pc', name: this.$t('displayQuality.high')},
        {type : 'mobile', name: this.$t('displayQuality.normal')}
      ],
    }
  },
  methods:{
    ...mapActions('user', [
      'changeUserVideoQuality',
    ]),
    async onClickQuality(quality){
      try{
        await this.changeUserVideoQuality({ 
            userId : this.me.userId,
            userVideoQuality : quality
          });
      } catch {
        this.$alert({
          text: this.$t('displayQuality.fail'),
          onlyOk: true,
        });
      }
    },
    onClose() {
      this.$modal('RoomQualitySettingModal')
    },
  }
}
//TODO 월모드일때 참여자에게도 보여야함
</script>

<style lang='scss' scoped>

.room-quality-modal-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;

  .room-setting-modal {
    display: flex;
    flex-direction: column;
    width: 350px;
    height: 500px;
    border-radius: 12px;
    background: #fff;
    transition: .5s ease all;
  }

  .room-setting-header{
    width: 100%;
    padding: 15px 20px;

    .room-setting-title-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      text-align: center;

      .room-setting-title {
        font-size: 16px;
        font-weight: 700;
        color: #333;
        line-height: 19px;
      }
    }
  }
  .room-setting-body{
    padding: 20px;
  }
}
[grm-device-mobile]{
  .room-setting-modal{
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
</style>